import React from 'react';

import type { OpenCloseStateResult } from 'src/hooks/shared';

export type GlobalStateContextValue = {
  leftMenuDrawerState: OpenCloseStateResult<any>;
};

export const GlobalStateContext = React.createContext({} as GlobalStateContextValue);
